import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-old-casino',
  templateUrl: './old-casino.component.html',
  styleUrls: ['./old-casino.component.scss'],
})
export class OldCasinoComponent implements OnInit {
  ngOnInit(): void {}
}
